import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { assets } from '../../assets';
import { BlurredContainer, ImageCircleBig } from '../containers/containers';
import { VerticalSeparator } from '../ui-utils/separators';

const TextContainer = styled.div``;

const ForwardIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`;

const TitleContainer = styled.title`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > h2 {
    margin-right: 10px;
  }
`;

const MenuCard = (props: {
  image: string;
  title: string;
  description: string;
  url: string;
}): JSX.Element => {
  const history = useHistory();

  const handleOnClick = (): void => {
    history.push(props.url);
  };

  return (
    <BlurredContainer
      className="flex flex-col xl:flex-row justify-between cursor-pointer"
      onClick={handleOnClick}
    >
      <ImageCircleBig src={props.image} />
      <VerticalSeparator className="mx-3 hidden xl:block" />
      <TextContainer>
        <TitleContainer>
          <h2>{props.title}</h2>
          <ForwardIcon src={assets.icons.forward_menu} />
        </TitleContainer>
        <p className="text-12">{props.description}</p>
      </TextContainer>
    </BlurredContainer>
  );
};

export default MenuCard;
